import { AircraftIcon } from '@icons';
import { AviaLegTypes, RouteLegTypeEnum } from '@/api/apis/route';
import { TmdxAviaInfo } from './TmdxAviaInfo';

type AviaTransportInfoProps = {
  leg: AviaLegTypes;
};

export const AviaTransportInfo = ({ leg }: AviaTransportInfoProps) => {
  switch (leg.legType) {
    case RouteLegTypeEnum.TmdxJetAviaLeg:
      return <TmdxAviaInfo leg={leg} showTailNumber />;
    case RouteLegTypeEnum.SupplementalLiftAviaLeg:
    case RouteLegTypeEnum.TxCenterProviderAviaLeg:
      return leg.tailNumber ? (
        <div className="flex items-center gap-1">
          <AircraftIcon width={24} height={24} />
          <span className="text-m-sb text-base-20 pt-0.5">{leg.tailNumber}</span>
        </div>
      ) : null;
    default:
      return null;
  }
};
